var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.00195312 1.49949C-0.00195312 1.1313 0.296524 0.832825 0.664714 0.832825H8.66471C9.0329 0.832825 9.33138 1.1313 9.33138 1.49949C9.33138 1.86768 9.0329 2.16616 8.66471 2.16616H1.33138V10.1662C1.33138 10.5343 1.0329 10.8328 0.664714 10.8328C0.296524 10.8328 -0.00195312 10.5343 -0.00195312 10.1662V1.49949Z",
    fill: "#9D9D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66992 4.16551C2.66992 3.79732 2.9684 3.49884 3.33659 3.49884H11.3366C11.7048 3.49884 12.0033 3.79732 12.0033 4.16551V12.1655C12.0033 12.6959 11.7925 13.2046 11.4175 13.5797C11.0424 13.9548 10.5337 14.1655 10.0033 14.1655H4.66992C4.13949 14.1655 3.63078 13.9548 3.25571 13.5797C2.88064 13.2046 2.66992 12.6959 2.66992 12.1655V4.16551ZM4.00326 4.83217V12.1655C4.00326 12.3423 4.07349 12.5119 4.19852 12.6369C4.32354 12.7619 4.49311 12.8322 4.66992 12.8322H10.0033C10.1801 12.8322 10.3496 12.7619 10.4747 12.6369C10.5997 12.5119 10.6699 12.3423 10.6699 12.1655V4.83217H4.00326Z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.0675b8e5cc49c7932550eca408a9c9cf.svg";
export { ForwardRef as ReactComponent };